import {
  CRYPTO_DEPOSIT_FEATURE_FLAG_CODE,
  CryptoDepositsUnavailableModalCallable,
} from 'app/_authenticated/funds/components/CryptoDepositsUnavailableModal';
import { useGetFeatureFlagsQuery } from 'store/slices/feature-flags-api';

/**
 * Gates every entry point into the crypto deposit flow behind the CRYPTODEP
 * feature flag. When the flag is active the flow is closed, so the call site
 * shows `CryptoDepositsUnavailableModal` instead of navigating.
 *
 * Wrap the navigation, don't branch around it:
 *
 *   const { guardCryptoDeposit } = useCryptoDepositGuard();
 *   guardCryptoDeposit(() => navigate({ to: '/funds/deposit/crypto' }));
 *
 * Pending orders are blocked too — if deposits are off, the address on the
 * crypto address page should not be used.
 */
export function useCryptoDepositGuard() {
  const { data: featureFlags } = useGetFeatureFlagsQuery();

  const isCryptoDepositAvailable =
    featureFlags?.find(flag => flag.code === CRYPTO_DEPOSIT_FEATURE_FLAG_CODE)
      ?.active ?? false;

  function guardCryptoDeposit(proceed: () => void) {
    if (!isCryptoDepositAvailable) {
      CryptoDepositsUnavailableModalCallable.call();
      return;
    }

    proceed();
  }

  return { guardCryptoDeposit };
}
